<template>
    <div class="achievements">
        <div class="container">
            <ul class="achievements__list">
                <li class="achievements__item" v-for="cijfer in cijfers" :key="cijfer.labelKey">
                    <h3 class="achievements__h3">
                        {{ toonwaarde(cijfer) }}<span v-if="cijfer.suffix">{{ cijfer.suffix }}</span>
                    </h3>
                    <p class="achievements__p">{{ $t('general.' + cijfer.labelKey) }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { currentCountValue, formatCount } from "../../../utils/counter";

// Duur van het oplopen. Korter dan een seconde valt nauwelijks op, langer dan
// twee seconden gaat vervelen bij wie al aan het lezen is.
const LOOPTIJD_MS = 1600;

export default {
    name: "achievements",
    data: () => ({
        // De eindwaarden komen uit de eigen databank (stand 16 september 2026):
        // 41.212 bestellingen in totaal, waarvan 22.058 in 2026.
        cijfers: [
            { target: 40000, suffix: "+", labelKey: "revenue-increase" },
            { target: 22000, suffix: "+", labelKey: "orders-this-year" },
            { target: 2600, suffix: "+", labelKey: "more-monthly-orders" },
            { target: 1, suffix: "", labelKey: "easy-to-use-solution" },
        ],
        verstreken: 0,
        gestart: false,
    }),
    computed: {
        // Zolang de animatie niet gestart is, staat alles op nul; daarna loopt
        // elke teller met dezelfde klok mee.
        klaar: function () {
            return this.verstreken >= LOOPTIJD_MS;
        },
    },
    methods: {
        toonwaarde: function (cijfer) {
            if (this.klaar) {
                return formatCount(cijfer.target);
            }
            return formatCount(currentCountValue(cijfer.target, this.verstreken, LOOPTIJD_MS));
        },
        start: function () {
            if (this.gestart) {
                return;
            }
            this.gestart = true;

            // Bezoekers die bewegende beelden liever vermijden, krijgen meteen
            // het eindgetal te zien.
            const liefstGeenBeweging =
                window.matchMedia &&
                window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            if (liefstGeenBeweging) {
                this.verstreken = LOOPTIJD_MS;
                return;
            }

            const beginTijd = performance.now();
            const stap = (nu) => {
                this.verstreken = nu - beginTijd;
                if (this.verstreken < LOOPTIJD_MS) {
                    this.animatieHandle = requestAnimationFrame(stap);
                } else {
                    this.verstreken = LOOPTIJD_MS;
                }
            };
            this.animatieHandle = requestAnimationFrame(stap);
        },
    },
    mounted() {
        // Pas tellen als het blok in beeld komt. Staat het boven de vouw, dan
        // vuurt de waarnemer meteen; scrollt de bezoeker er later naartoe, dan
        // ziet hij de animatie alsnog in plaats van een al afgelopen teller.
        if (!("IntersectionObserver" in window)) {
            this.start();
            return;
        }
        this.waarnemer = new IntersectionObserver(
            (aantekeningen) => {
                if (aantekeningen.some((aantekening) => aantekening.isIntersecting)) {
                    this.start();
                    this.waarnemer.disconnect();
                }
            },
            { threshold: 0.3 }
        );
        this.waarnemer.observe(this.$el);
    },
    beforeDestroy() {
        // Zonder opruimen blijft er een animatielus en een waarnemer achter als
        // de bezoeker wegnavigeert voor de teller klaar is.
        if (this.animatieHandle) {
            cancelAnimationFrame(this.animatieHandle);
        }
        if (this.waarnemer) {
            this.waarnemer.disconnect();
        }
    },
};
</script>
<style lang="scss" scoped>
.achievements {
    margin: 30px 0;

    .achievements__list {
        display: flex;
        justify-content: space-evenly;
        align-items: flex-start;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        .achievements__item {
            padding: 5px;
            margin: 5px;
            text-align: center;
            list-style: none;

            .achievements__h3 {
                font-size: 48px;
                font-weight: bold;

                // Cijfers hebben in dit lettertype niet allemaal dezelfde
                // breedte. Tijdens het oplopen zou de teller daardoor zichtbaar
                // heen en weer schokken.
                font-variant-numeric: tabular-nums;
                font-feature-settings: "tnum";
            }

            .achievements__p {
                font-size: 16px;
                line-height: 26px;
                max-width: 220px;
            }
        }
    }
}
</style>
